<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <action-toolbar-buttons [grid]="grid" [canEdit]="canEdit" [showAdd]="false" [showEdit]="false" [showDelete]="false"></action-toolbar-buttons>
                @if (canEdit) {
                    <button type="button" class="btn btn-primary btn-sm me-2" (click)="addSite()">Add Site</button>
                }
                <select class="form-select form-select-sm me-2" style="width: auto" [(ngModel)]="statusFilter" name="statusFilter" (ngModelChange)="applyFilter()">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="all">All</option>
                </select>
                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                <grid-export [grid]="mainGrid" [name]="'SWPPP Sites'"></grid-export>
            </form>
        </div>
    </div>
    <wj-flex-grid id="swpppSitesGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" (destroy)="grid.destroy()" [itemsSource]="grid.view">
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'">
            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                <a href="javascript:void(0)" (click)="openSite(cell.item)">{{ cell.item.name }}</a>
            </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Disturbed acres'" [binding]="'disturbedAcreage'" [width]="140"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Active'" [binding]="'isActive'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Last 24h precip'" [binding]="'lastPrecip24hInches'" [width]="140"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'48h rain chance'" [binding]="'forecast48hPrecipChance'" [width]="140"></wj-flex-grid-column>
    </wj-flex-grid>
</div>
